import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate, Trans} from "react-i18next";
import {Row, Col} from "reactstrap";
import iconCloseButton from "../media/icons/closeButton.png"
import {STAGES} from "../pages/Stage";

class SubPageTopBar extends React.Component {
    constructor(props){
        super(props);
    }

    render() {
        let progressIndicator;
        switch (this.props.progress) {
            case 0:
                progressIndicator = <span />;
                break;
            case 2:
                progressIndicator = <p style={{fontSize:"18px", color:"black"}}>
                    <span style={{marginRight:"10px"}}>●</span>
                    <span style={{marginRight:"10px"}}>●</span>
                    <span style={{color:"#333333", opacity:"0.2"}}>●</span>
                </p>;
                break;
            case 3:
                progressIndicator = <p style={{fontSize:"18px", color:"black"}}>
                    <span style={{marginRight:"10px"}}>●</span>
                    <span style={{marginRight:"10px"}}>●</span>
                    <span>●</span>
                </p>;
                break;
            default:
                progressIndicator = <p style={{fontSize:"18px",color:"black"}}>
                    <span style={{marginRight:"10px"}}>●</span>
                    <span style={{color:"#333333", opacity:"0.2", marginRight:"10px"}}>●</span>
                    <span style={{color:"#333333", opacity:"0.2"}}>●</span>
                </p>
        }

        return <Row>
            <Col xs={6} style={{marginTop:"15px"}}>
                {progressIndicator}
            </Col>
            <Col xs={6} style={{marginTop:"15px"}}>
                <img
                    src={iconCloseButton}
                    style={{float:"right"}}
                    onClick={this.props.onClickClose}
                />
            </Col>
        </Row>
    }
}

export default translate("translations")(SubPageTopBar);